import React, { useCallback, useContext, useEffect, useState } from "react";
import inputBgLg from "@assets/images/backgrounds/inputBgLg.webp";
import inputBgMd from "@assets/images/backgrounds/inputBgMd.webp";
import { UserContext } from "@src/context/UserContext";
import { emailRegex } from "@src/utils/Regex";
import useApiHook from "@src/hooks/useApiHook";
import useApiError from "@src/hooks/useApiError";
import { ChangeEmailContext } from "@src/context/ChangeEmailContext";
import type { IChangeEmailComp } from "@src/types/AppTypes";

const ChangeEmail = React.forwardRef<HTMLDivElement, IChangeEmailComp>(
  (
    {
      changeemailModal,
      modalBorder,
      setChangeEmailModal,
      updateEmailMutate,
      isLoading,
    },
    ref
  ) => {
    const user = useContext(UserContext);
    const [currentEmail, setCurrentEmail] = useState<string>(user?.email ?? "");
    const [newEmail, setNewEmail] = useState<string>("");
    const [newEmailerror, setnewEmailerror] = useState<boolean>(false);
    const [currentPassword, setCurrentPassword] = useState<string>("");
    const [showPassword, setShowPassword] = useState<boolean>(false);
    const { emailData, setEmailData } = useContext(ChangeEmailContext);
    const setApiError = useApiError();
    const [error, setError] = useState<{
      type: "currentEmail" | "newEmail" | "password";
      value: string;
    } | null>(null);
    const checkEmailEnpoint = useApiHook({
      url: "/users/check_emails",
      method: "post",
    });

    const checkEmail = useCallback(
      async (email: string) => {
        try {
          const res = await checkEmailEnpoint<{
            status: boolean;
            message: string;
          }>({ email });
          if (res?.data?.status) {
            setnewEmailerror(true);
            // flashNotification({ status: false, message: res.data.message });
          } else {
            setnewEmailerror(false);
          }
        } catch (e) {
          setApiError(e);
        }
      },
      [setApiError, checkEmailEnpoint]
    );

    // useEffect(() => {
    //   let timeout: NodeJS.Timeout | null;
    //   if (error) {
    //     timeout = setTimeout(() => {
    //       setError(null);
    //     }, 3000);
    //   }

    //   return () => {
    //     if (timeout) {
    //       clearTimeout(timeout);
    //     }
    //   };
    // }, [error]);

    useEffect(() => {
      const email = emailData.email;
      const password = emailData.password;
      if (email && password) {
        setNewEmail(email);
        setCurrentPassword(password);
      }
    }, [emailData]);

    // back bg scroll stop :-

    useEffect(() => {
      const header = document.getElementById("header");
      const footer = document.getElementById("footer");

      document.body.style.overflow = "hidden";
      document.body.style.width = "100%";

      if (header) {
        header.style.zIndex = "0";
      }
      if (footer) {
        footer.style.zIndex = "-1";
      }

      return () => {
        // Enable background scroll
        document.documentElement.style.overflow = "";
        document.body.style.overflow = "auto";
        document.body.style.width = "";

        if (header) {
          header.style.zIndex = "";
        }
        if (footer) {
          footer.style.zIndex = "";
        }
      };
    }, []);

    return (
      <div>
        <div
          className={`fixed w-full h-full bg-[#00000080] top-0 left-0 grid place-items-center z-[999] modal-content overflow-hidden ${
            changeemailModal ? "block" : "hidden"
          }`}
        >
          <div
            id="change-email-form"
            ref={ref}
            onAnimationEnd={() => {
              document
                .getElementById("change-email-form")
                ?.classList.remove("form-shake");
            }}
            className="max-w-xl w-full bg-gradient-to-b from-[#1D1159] to-[#00AEEF] relative rounded-[5px_30px_40px_0px] max-sm:max-w-[95%]"
          >
            <img
              src={modalBorder}
              className="absolute top-0 left-0 w-full h-full z-[0]"
              alt=""
            />
            <div className="relative z-10 px-10 my-6 max-md:px-6 max-sm:px-4 max-h-[78dvh] overflow-auto">
              <div className="grid grid-cols-[36px_1fr_36px]">
                <div></div>
                <h2 className="text-primary text-center uppercase text-3xl max-md:text-2xl max-sm:text-xl">
                  Change Email
                </h2>
                <button
                  onClick={() => {
                    setChangeEmailModal(!changeemailModal);
                    setCurrentEmail("");
                    setNewEmail("");
                    setCurrentPassword("");
                    setEmailData({
                      type: "changeEmail",
                      payload: { email: "", password: "" },
                    });
                    sessionStorage.clear();
                  }}
                  className="text-primary text-4xl max-md:text-2xl ml-auto duration-150 hover:scale-95"
                  aria-label="Close"
                >
                  <i className="ri-close-circle-line"></i>
                </button>
              </div>
              <div className="text-center mt-10 max-w-md mx-auto max-sm:mt-5">
                <div className="grid grid-cols-1 gap-7 max-md:gap-5 max-sm:grid-cols-1 text-start mb-8">
                  <div>
                    <label
                      className="text-primary text-base mb-1 f-family-mochiy-pop block"
                      htmlFor="accountCurrentEmail"
                    >
                      Current Email Address *
                    </label>
                    <div className="relative">
                      <input
                        id="accountCurrentEmail"
                        value={currentEmail}
                        onChange={(e) => {
                          setCurrentEmail(e.target.value),
                            setError({
                              type: "currentEmail",
                              value: "",
                            });
                        }}
                        autoCapitalize="none"
                        inputMode="text"
                        className="relative p-5 z-10 text-base w-full bg-transparent text-black placeholder:text-[#9CA3AF] f-family-mochiy-pop"
                        placeholder="Enter Current Email"
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === "NumpadEnter") {
                            e.preventDefault();
                            document.getElementById("accountNewEmail")?.focus();
                          }
                        }}
                      />
                      <img
                        className="absolute top-0 left-0 w-full h-full"
                        src={inputBgLg}
                        alt=""
                      />
                    </div>
                    <span className="text-red-400 f-family-mochiy-pop text-base font-medium mt-1 block">
                      {error?.type === "currentEmail" && error.value}
                    </span>
                  </div>
                  <div>
                    <label
                      className="text-primary text-base mb-1 f-family-mochiy-pop block"
                      htmlFor="accountNewEmail"
                    >
                      New Email Address *
                    </label>
                    <div className="relative">
                      <input
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === "NumpadEnter") {
                            e.preventDefault();
                            document.getElementById("accountPass")?.focus();
                          }
                        }}
                        id="accountNewEmail"
                        value={newEmail}
                        inputMode="text"
                        autoCapitalize="none"
                        onChange={(e) => {
                          if (newEmailerror) {
                            setnewEmailerror(false);
                          }
                          setNewEmail(e.target.value);
                          setError({
                            type: "newEmail",
                            value: "",
                          });
                        }}
                        onBlur={async () => {
                          if (newEmailerror) {
                            setError({
                              type: "newEmail",
                              value:
                                "An account with this email address already exists.",
                            });
                          }
                          if (emailRegex.test(newEmail))
                            await checkEmail(newEmail.toLowerCase());
                        }}
                        className="relative p-5 z-10 text-base w-full bg-transparent text-black placeholder:text-[#9CA3AF] f-family-mochiy-pop"
                        placeholder="Enter New email"
                      />
                      <img
                        className="absolute top-0 left-0 w-full h-full"
                        src={inputBgMd}
                        alt=""
                      />
                    </div>
                    <span className="text-red-400 f-family-mochiy-pop text-base font-medium mt-1 block">
                      {newEmailerror
                        ? "An account with this email address already exists."
                        : error?.type === "newEmail" && error.value}
                    </span>
                  </div>
                  <div>
                    <label
                      className="text-primary text-base mb-1 f-family-mochiy-pop block"
                      htmlFor="accountPass"
                    >
                      Password *
                    </label>
                    <div className="relative">
                      <input
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === "NumpadEnter") {
                            e.preventDefault();
                            document.getElementById("accountPass")?.blur();
                          }
                        }}
                        id="accountPass"
                        value={currentPassword}
                        type={showPassword ? "text" : "password"}
                        onChange={(e) => {
                          setCurrentPassword(e.target.value),
                            setError({
                              type: "password",
                              value: "",
                            });
                        }}
                        className="relative p-5 pe-12 z-10 text-base w-full bg-transparent text-black placeholder:text-[#9CA3AF] f-family-mochiy-pop"
                        placeholder="Enter password"
                        autoComplete="new-password"
                      />
                      <img
                        className="absolute top-0 left-0 w-full h-full"
                        src={inputBgMd}
                        alt=""
                      />
                      <i
                        onClick={() => {
                          setShowPassword(!showPassword);
                        }}
                        className={`hover:cursor-pointer text-black z-[10] absolute right-5 top-2/4 -translate-y-2/4 ${
                          showPassword ? "ri-eye-off-fill" : "ri-eye-fill"
                        } text-2xl`}
                      ></i>
                    </div>
                    <span className="text-red-400 f-family-mochiy-pop text-base font-medium block mt-1">
                      {error?.type === "password" && error.value}
                    </span>
                  </div>
                </div>
                <button
                  disabled={
                    !currentEmail ||
                    !newEmail ||
                    !currentPassword ||
                    isLoading ||
                    newEmailerror ||
                    currentEmail.toLowerCase() == newEmail.toLowerCase()
                  }
                  onClick={async (e) => {
                    if (currentEmail.trim().length === 0) {
                      setError({
                        type: "currentEmail",
                        value: "Please enter an email address.",
                      });
                      return;
                    } else if (!emailRegex.test(currentEmail)) {
                      setError({
                        type: "currentEmail",
                        value: "Please enter valid email address.",
                      });
                      return;
                    } else if (newEmail.trim().length === 0) {
                      setError({
                        type: "newEmail",
                        value: "Please enter an email address.",
                      });
                      return;
                    } else if (!emailRegex.test(newEmail)) {
                      setError({
                        type: "newEmail",
                        value: "Please enter valid email address.",
                      });
                      return;
                    } else if (currentPassword.trim().length === 0) {
                      setError({
                        type: "password",
                        value: "Please enter password.",
                      });
                      return;
                    }
                    setChangeEmailModal(true);

                    // storing new email and old password, if user come back to this page after go to verification code modal
                    setEmailData({
                      type: "changeEmail",
                      payload: { email: newEmail, password: currentPassword },
                    });
                    e.preventDefault();
                    await updateEmailMutate({
                      data: {
                        current_email: currentEmail,
                        new_email: newEmail.toLowerCase(),
                        password: currentPassword,
                      },
                    });
                    setCurrentEmail("");
                    setNewEmail("");
                    setCurrentPassword("");
                  }}
                  className="text-2xl max-md:text-xl customized-button w-full flex items-center justify-center"
                  aria-label="Next"
                >
                  {isLoading ? (
                    <i className="ri-loop-right-line btn-loader"></i>
                  ) : (
                    "Next"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default ChangeEmail;
